export default __webpack_public_path__ + "static/media/241104_Shop_Bilder_3.b9a18891.png";